module.exports = require("core-js/modules/es.regexp.exec.js");